module.exports = " <div class=hello> <h1>{{ msg }}</h1> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
 ** module id = 652
 ** module chunks = 2
 **/